// extracted by mini-css-extract-plugin
export default {"Checkbox":"PwwRU24fin2wpdqqSNMG"};